<template>
  <b-container class="wrap-category">
    <Title
      main="C A T E G O R I E S"
      des="ADMAN 2019"
    />

    <b-row class="box-btn">
      <b-col
        v-for="(btn, i) in btns"
        :key="i"
        cols="12"
        md="6"
        class="col"
      >
        <a :href="btn.link" target="_blank">
          <div>{{ btn.title }}</div>
        </a>
      </b-col>
    </b-row>
    <b-row>
      <b-col
        v-for="category in categoriesList"
        :key="category.id"
        @click.prevent="clickToDetail(category.id)"
        cols="12"
        md="3"
      >
        <Card :data="category" />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapState } from 'vuex'

const Title = () => import('@/components/About/Parts/Title')
const Card = () => import('./Card')

export default {
  components: {
    Title,
    Card
  },

  computed: {
    ...mapState({
      categoriesList: state => state.awards.categoriesList,
      links: state => state.awards.links
    })
  },

  data () {
    return {
      btns: [
        {
          title: 'Download Full Entry Kit',
          link: ''
        },
        {
          title: 'Download Client Endorsement Form',
          link: ''
        }
      ]
    }
  },

  methods: {
    clickToDetail (id) {
      this.$store.dispatch('awards/getCateDetail', id)

      this.$router.push({
        name: 'category-detail',
        params: {
          id: id
        }
      })
    },

    matchLinkBtn (data) {
      data.forEach(item => {
        this.btns[0].link = `https://admanawards.com/storage/app/pdf/award/${item.link1}`
        this.btns[1].link = `https://admanawards.com/storage/app/pdf/award/${item.link2}`
      })
    }
  },

  created () {
    if (this.links) {
      this.matchLinkBtn(this.links)
    }
  },

  watch: {
    links (data) {
      this.matchLinkBtn(data)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.wrap-category {
  padding: 22px;

  .box-btn {
    .col {
      margin-bottom: 12px;

      a {
        div {
          padding: 12px 0;
          border-bottom: 3px solid #58595B;
          background-color: #C4C5C5;
          text-align: center;
          font-size: 1.25rem;
          color: white;
        }
      }
    }
  }
}
</style>
